import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { CTAButton } from '../../components'
import { Space, Table } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import moment from 'moment'
import { useRouter } from '../../../../routes'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%'
    },
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    content: {
        padding: theme.spacing(3, 0)
    }
}))

/**
 * Admin view page for registered tools
 *
 * Admin can create a new tool by clicking on the `New Tool` button and providing values for the input form.
 * The button opens NewTool drawer with input fields and submit button.
 */

const ToolsAdminPage = () => {
    const [tools, setTools] = useState([])
    const [showAddTool, setShow] = useState(false)

    const classes = useStyles()
    const data = useData()
    const router = useRouter()

    const toolsApi = data.tools()

    // load tools
    const loadTools = () => {
        trackPromise(
            toolsApi.getAllTools()
                .then(setTools)
                // .then(console.log)
                .catch(console.log)
        )
    }

    useEffect(() => {
        loadTools()

        // eslint-disable-next-line
    }, [])

    /**
     * Close new tool drawer and reload tool
     */
    const closeAndReload = () => {
        setShow(false)
        loadTools()
    }

    /**
     * Show drawer to create a new tool
     */
    const newTool = () => setShow(true)


    /**
     * Navigate to tool details on tools page
     */
    const showTool = (tool) => {
        const { id } = tool

        return router.push('/dashboard/tool', { id })
    }

    const { promiseInProgress } = usePromiseTracker()

    // tools table schema
    const toolsSchema = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'Id'
        },
        {
            key: 'name',
            dataIndex: 'name',
            title: 'name'
        },
        {
            key: 'avg',
            dataIndex: 'avg_run_time',
            title: 'Average time',
            render: (text, _) => moment.utc(moment.duration(text, 's').asMilliseconds()).format("HH:mm:ss")
        },
        {
            key: 'cat',
            dataIndex: 'category',
            title: 'Category'
        },
        {
            key: 'type',
            dataIndex: 'type',
            title: 'Type'
        },
        {
            key: 'cookie_key',
            dataIndex: 'cookie_key',
            title: 'Cookie Key'
        },
        {
            key: 'created_by',
            title: 'Creator',
            dataIndex: 'created_by',
        },
        {
            key: 'created',
            title: 'Created At',
            dataIndex: 'created_at',
            render: (text, _) => moment(text).format('YYYY-MM-DD HH:mm')
        },
        {
            key: 'spider',
            title: 'Spider',
            dataIndex: 'spider_name',
        },
        {
            key: 'is_cookies_required',
            title: 'IS Cookies required',
            dataIndex: 'is_cookies_required',
        },
    ]

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <h1> Tools ({tools.length}) </h1>
                <CTAButton
                    onClick={newTool}
                >
                    <Space>
                        <PlusOutlined />
                        New Tool
                    </Space>
                </CTAButton>
            </div>

            <div className={classes.content}>
                <Table
                    columns={toolsSchema}
                    dataSource={tools}
                    onRow={(record, _) => ({
                        onClick: () => showTool(record)
                    })}
                    loading={promiseInProgress}
                />


            </div>
        </div>
    )
}

export default ToolsAdminPage
